import {
  ADD_BATCH_GIFT,
  ADD_PAYMENT_METHOD,
  ADD_TO_PARISH,
  ALERT_EDITOR,
  ARCHIVE_FUND,
  ARCHIVE_USER,
  ASK_THE_MEMBER,
  BILLING_LOCKOUT,
  CAMPAIGNS_SPLASH,
  CAMPAIGN_WIZARD,
  CANCEL_FLOCKNOTE_COMPLETE,
  CONTACT_HISTORY,
  CREATE_ADDON_GIFT,
  CREATE_FUND,
  CREATE_GIVING_HOUSEHOLD,
  CREATE_GROUP,
  CREATE_PLEDGE,
  CREATE_PLEDGE_OVERLAY,
  CREATE_PRAYER_REQUEST,
  CTA_EDITOR,
  DISCOUNT_DETAIL_MODAL,
  DONOR_SUMMARY_REPORTS,
  EDIT_PLEDGE,
  EMERGENCY_CONTACT_HISTORY,
  EVERYONE_REMOVE_MEMBER_CONFIRMATION,
  EXTENDED_FIELDS,
  EXTENDED_FIELD_HISTORY,
  FAMILY_REGISTRATION_SPLASH,
  FAMILY_RELATIONSHIP_PICKER,
  FNC_SMART_GROUP_PROMO,
  FNC_SMART_GROUP_UPGRADE_GROUP_LIMIT,
  FNC_UPGRADE,
  GIFT_REFUND,
  GIVING_SPLASH,
  IMPORTING,
  LEGAL_ENTITY_INFO,
  MAKE_SUBGROUP,
  MANAGE_MY_GIVING_SPLASH,
  MANAGE_PROXY_CONTACTS,
  MEDICAL_ALLERGY_HISTORY,
  NEW_CAMPAIGN,
  PARENT_GROUP_PERMISSION_CONFLICT,
  PAYMENT_DATES,
  PLEDGE_DETAIL,
  PLEDGE_HISTORY,
  PREPARING_EXPORT,
  REMOVE_SUB_FUND,
  RE_SETUP_WIZARD,
  SACRAMENT_HISTORY,
  SACRAMENT_TRACKING,
  SMALL_CHURCH_ATTESTATION,
  STAX_KYC,
  TRANSFER_PARTIAL_CONTACT_VIEW_IN_SHEET,
  TTJ_ACTION_FLOW,
  TWO_FA_DISENROLLMENT,
  TWO_FA_ENROLLMENT,
} from "./contentKeys";

const configsByContentKey = {
  flexHeight: {
    [ADD_BATCH_GIFT]: true,
    [ADD_TO_PARISH]: true,
    [BILLING_LOCKOUT]: true,
    [CREATE_ADDON_GIFT]: true,
    [CREATE_GROUP]: true,
    [CTA_EDITOR]: true,
    [GIFT_REFUND]: true,
    [FNC_UPGRADE]: true,
    [SACRAMENT_TRACKING]: true,
    [MANAGE_PROXY_CONTACTS]: true,
    [FAMILY_RELATIONSHIP_PICKER]: true,
    [EXTENDED_FIELD_HISTORY]: true,
    [EVERYONE_REMOVE_MEMBER_CONFIRMATION]: true,
    [PARENT_GROUP_PERMISSION_CONFLICT]: true,
    [ASK_THE_MEMBER]: true,
    [CONTACT_HISTORY]: true,
    [SACRAMENT_HISTORY]: true,
    [EMERGENCY_CONTACT_HISTORY]: true,
    [MEDICAL_ALLERGY_HISTORY]: true,
    [FNC_SMART_GROUP_PROMO]: true,
    [FAMILY_REGISTRATION_SPLASH]: true,
    [GIVING_SPLASH]: true,
    [CAMPAIGNS_SPLASH]: true,
    [MANAGE_MY_GIVING_SPLASH]: true,
    [FNC_SMART_GROUP_UPGRADE_GROUP_LIMIT]: true,
    [PREPARING_EXPORT]: true,
    [LEGAL_ENTITY_INFO]: true,
    [CREATE_PRAYER_REQUEST]: true,
    [SMALL_CHURCH_ATTESTATION]: true,
    [TTJ_ACTION_FLOW]: true,
    [CREATE_GIVING_HOUSEHOLD]: true,
    [CREATE_PLEDGE]: true,
    [CREATE_PLEDGE_OVERLAY]: true,
    [CREATE_FUND]: true,
    [PLEDGE_DETAIL]: true,
    [EDIT_PLEDGE]: true,
    [PLEDGE_HISTORY]: true,
    [PAYMENT_DATES]: true,
    [ADD_PAYMENT_METHOD]: true,
    [ARCHIVE_USER]: true,
    [IMPORTING]: true,
    [MAKE_SUBGROUP]: true,
    [NEW_CAMPAIGN]: true,
    [DISCOUNT_DETAIL_MODAL]: true,
    [REMOVE_SUB_FUND]: true,
    [CANCEL_FLOCKNOTE_COMPLETE]: true,
    [ARCHIVE_FUND]: true,
  },
  flexWidth: {
    [CTA_EDITOR]: true,
    // Its panels animate between two different widths, so each states its own
    // and the shell follows instead of pinning them all to one.
    [PLEDGE_DETAIL]: true,
    [GIFT_REFUND]: true,
    [STAX_KYC]: true,
    [FNC_UPGRADE]: true,
    [FAMILY_RELATIONSHIP_PICKER]: true,
    [TTJ_ACTION_FLOW]: true,
    [IMPORTING]: true,
    [TRANSFER_PARTIAL_CONTACT_VIEW_IN_SHEET]: true,
  },
  maxWidth: {
    [ADD_TO_PARISH]: "550px",
    [BILLING_LOCKOUT]: "480px",
    [CREATE_ADDON_GIFT]: "500px",
    [SACRAMENT_TRACKING]: "1000px",
    [TWO_FA_ENROLLMENT]: "550px",
    [TWO_FA_DISENROLLMENT]: "500px",
    [DONOR_SUMMARY_REPORTS]: "720px",
    [EXTENDED_FIELD_HISTORY]: "550px",
    [EVERYONE_REMOVE_MEMBER_CONFIRMATION]: "420px",
    [PARENT_GROUP_PERMISSION_CONFLICT]: "420px",
    [MEDICAL_ALLERGY_HISTORY]: "550px",
    [EMERGENCY_CONTACT_HISTORY]: "550px",
    [ASK_THE_MEMBER]: "600px",
    [CONTACT_HISTORY]: "550px",
    [SACRAMENT_HISTORY]: "550px",
    [CREATE_GROUP]: "550px",
    [FNC_SMART_GROUP_PROMO]: "600px",
    [FAMILY_REGISTRATION_SPLASH]: "600px",
    [GIVING_SPLASH]: "600px",
    [CAMPAIGNS_SPLASH]: "600px",
    [MANAGE_MY_GIVING_SPLASH]: "600px",
    [FNC_SMART_GROUP_UPGRADE_GROUP_LIMIT]: "600px",
    [PREPARING_EXPORT]: "420px",
    [LEGAL_ENTITY_INFO]: "550px",
    [CREATE_PRAYER_REQUEST]: "600px",
    [SMALL_CHURCH_ATTESTATION]: "640px",
    [CREATE_GIVING_HOUSEHOLD]: "560px",
    [CAMPAIGN_WIZARD]: "900px",
    [CREATE_PLEDGE]: "600px",
    [CREATE_PLEDGE_OVERLAY]: "560px",
    [CREATE_FUND]: "450px",
    [EDIT_PLEDGE]: "560px",
    [PLEDGE_HISTORY]: "520px",
    [PAYMENT_DATES]: "400px",
    [ADD_PAYMENT_METHOD]: "450px",
    [ARCHIVE_USER]: "420px",
    [MAKE_SUBGROUP]: "640px",
    [NEW_CAMPAIGN]: "462px",
    [REMOVE_SUB_FUND]: "360px",
    [RE_SETUP_WIZARD]: "980px",
    [DISCOUNT_DETAIL_MODAL]: "600px",
    [CANCEL_FLOCKNOTE_COMPLETE]: "785px",
    [ARCHIVE_FUND]: "380px",
  },
  scrollable: {
    [EXTENDED_FIELDS]: true,
  },
  maxHeight: {
    [EXTENDED_FIELDS]: "700px",
    [STAX_KYC]: "600px",
    [TWO_FA_ENROLLMENT]: "450px",
    [TWO_FA_DISENROLLMENT]: "400px",
    [DONOR_SUMMARY_REPORTS]: "640px",
    [CAMPAIGN_WIZARD]: "min(80vh, 680px)",
    [RE_SETUP_WIZARD]: "920px",
  },
  noMaxHeight: {
    [IMPORTING]: true,
  },
  minHeight: {
    [SACRAMENT_TRACKING]: "600px",
    [CREATE_PRAYER_REQUEST]: "323px",
    [CAMPAIGN_WIZARD]: "520px",
    [MAKE_SUBGROUP]: "400px",
  },
  legacy: {
    [CREATE_ADDON_GIFT]: true,
    [CTA_EDITOR]: true,
    [GIFT_REFUND]: true,
    [EXTENDED_FIELDS]: true,
    [ALERT_EDITOR]: true,
  },
  closeButtonPosition: {
    // position string or "hide"
    [CAMPAIGN_WIZARD]: "upperRight",
  },
  closeOnBackgroundClick: {
    [ASK_THE_MEMBER]: true,
    [CONTACT_HISTORY]: true,
    [SACRAMENT_HISTORY]: true,
    [EXTENDED_FIELD_HISTORY]: true,
    [MEDICAL_ALLERGY_HISTORY]: true,
    [EMERGENCY_CONTACT_HISTORY]: true,
    [PLEDGE_DETAIL]: true,
    [PLEDGE_HISTORY]: true,
    [PAYMENT_DATES]: true,
  },
  overflowY: {
    [IMPORTING]: "visible",
  },
  borderRadius: {
    [RE_SETUP_WIZARD]: "32px",
  },
  // Keys that take over the full viewport (edge to edge) at <=680px. Desktop
  // sizing is unchanged.
  fullScreenOnMobile: {
    [CAMPAIGN_WIZARD]: true,
  },
};

export default configsByContentKey;
